import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/dto.js';
import { TaxIdentificationDetails } from '../../models/serializable/invoicing/tax-identification-details.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class TaxIdentifierTrackingComponent extends Component {
  static readonly TYPE_ID: string = 'a3bb9813e0a04a0fa115538173c056c2';

  private constructor(
    public readonly isRequired: boolean,
    public readonly details: TaxIdentificationDetails | null,
  ) {
    super();
  }

  get isValid(): boolean {
    return !this.isRequired || this.details != null;
  }

  get $typeId(): string {
    return TaxIdentifierTrackingComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static required(): TaxIdentifierTrackingComponent {
    return new TaxIdentifierTrackingComponent(true, null);
  }

  static fulfilled({ details }: { details: TaxIdentificationDetails }): TaxIdentifierTrackingComponent {
    return new TaxIdentifierTrackingComponent(true, details);
  }

  static fromMap(context: SerializationContext, map: SerializedData): TaxIdentifierTrackingComponent {
    return new TaxIdentifierTrackingComponent(
        MapUtils.get<boolean>(map, 'isRequired'),
        context.fromDataOrNull<TaxIdentificationDetails>(MapUtils.getOrNull<SerializedData>(map, 'details')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'isRequired': this.isRequired,
      'details': context.toDataOrNull(this.details),
    };
  }

  clone(): this {
    return new TaxIdentifierTrackingComponent(
        this.isRequired,
        this.details?.clone() ?? null,
    ) as this;
  }

  isSame(other: TaxIdentifierTrackingComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.isRequired == this.isRequired &&
      isSameData(other.details, this.details);
  }
}

export class TaxIdentifierTrackingComponentBuilder extends DataModelBuilder<TaxIdentifierTrackingComponent> {
  build(context: SerializationContext, map: SerializedData): TaxIdentifierTrackingComponent {
    return TaxIdentifierTrackingComponent.fromMap(context, map);
  }
}
